export enum Provider {
  ALL = 'all',
  ANONYMOUS = 'anonymous',
  EMAIL_AND_PASSWORD = 'firebase',
  GOOGLE = 'google',
  APPLE = 'apple',
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  GITHUB = 'github',
  MICROSOFT = 'microsoft',
  YAHOO = 'yahoo',
  PHONE_NUMBER = 'phoneNumber',
  FIREBASE = 'firebase'
}
